// thing:export
import { copyVectors } from "@thi.ng/vectors/copy";
/** @internal */
export const __copyAttribs = ($) => ({ ...$.attribs });
/** @internal */
export const __copyShape = (ctor, inst) => new ctor(copyVectors(inst.points), __copyAttribs(inst));
